import $ from 'jquery';
import 'bootstrap';
import bowser from 'bowser';
import cf_const from './cf_const';
import './config/debug-config';
import '../../source/javascripts/vendor/admin/vendor/jquery.deserialize';
import '../../source/javascripts/vendor/admin/vendor/jquery.string.1.0';
import './config/fuelux-config';
import '../../source/javascripts/vendor/metisMenu';
import './ui/side_manu';
import './ui/ibox';
import './app';

// jQuery curCss Error – Quick Fix
jQuery.curCSS = jQuery.css;

// jQuery jQuery.browser.msie Error – Quick Fix
jQuery.browser = {};
jQuery.browser.msie = bowser.msie;


require('fancybox')($);



// WEBPACK FOOTER //
// ./es6/admin-common-js/index.js